import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import Moment from 'moment';

export const baseURI = '/empresas/zonas-exclusivas/';

/**
 * GET ZonaExclusivas
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getZonaExclusivas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET ZonaExclusiva
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getZonaExclusiva = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST ZonaExlusiva
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postZonaExclusiva = async (values) => {
  try {
    const valuesEntidad = values;
    valuesEntidad.entidad = 1;
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH ZonaExclusiva
 * @param {number} id
 * @param {object} _values
 * @returns {Promise<object|boolean>}
 */
export const patchZonaExclusiva = async (id, _values) => {
  try {
    const values = {
      ..._values,
      fecha_de_ultimo_movimiento: Moment(),
    };
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE ZonaExclusiva
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteZonaExclusiva = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET Zonas Exclusivas para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */

export const getZonasExclusivasCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/zonas-exclusivas-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
